/**
 * Showroom photography, in-store b-roll and the Instagram reels.
 * All files are produced by `node scripts/build-media.js`.
 */

const shot = (slug, alt, span = 1) => ({
  slug,
  alt,
  span,
  src: `/media/showroom/${slug}.webp`,
  thumb: `/media/showroom/${slug}-sm.webp`,
});

/** `span: 2` pieces run double-width in the gallery mosaic. */
export const showroom = [
  shot('showroom-04', 'The main counter running the length of the showroom', 2),
  shot('showroom-01', 'Rajendra Jewellers storefront on C G Road'),
  shot('showroom-08', 'Lit display niches along the showroom wall'),
  shot('showroom-05', 'Clients being shown jewellery at the counter', 2),
  shot('showroom-11', 'The shrine at the heart of the showroom'),
  shot('showroom-09', 'Seating along the consultation counter'),
  shot('showroom-02', 'Gold signage above the showroom entrance', 2),
  shot('showroom-06', 'A piece being presented across the counter'),
  shot('showroom-07', 'Looking down the length of the showroom floor'),
  shot('showroom-10', 'The team behind the counter', 2),
  shot('showroom-12', 'Wide view across the showroom counter'),
  shot('showroom-03', 'Showroom entrance doors'),
];

export const owner = {
  src: '/media/showroom/owner.webp',
  alt: 'The Rajendra Jewellers team seated in the showroom office',
};

/** Silent, looping in-store b-roll. */
export const ambience = [
  { slug: 'ambience-01', src: '/media/video/ambience-01.mp4', poster: '/media/video/ambience-01.jpg', alt: 'Daylight across the showroom floor' },
  { slug: 'ambience-03', src: '/media/video/ambience-03.mp4', poster: '/media/video/ambience-03.jpg', alt: 'A tray of rings in a lit display niche' },
];

/**
 * Look a clip up by slug rather than by array position — dropping a clip from
 * the list above should not silently repoint whichever section held its index.
 */
export const ambienceClip = (slug) => ambience.find((clip) => clip.slug === slug);

const reel = (slug, title, caption) => ({
  slug,
  title,
  caption,
  src: `/media/video/${slug}.mp4`,
  poster: `/media/video/${slug}.jpg`,
});

export const reels = [
  reel('reel-01', 'Diamond & Emerald', 'A layered diamond necklace with an emerald drop'),
  reel('reel-02', 'Studio Portrait', 'Emerald necklace and matched earrings on camera'),
  reel('reel-03', 'Choker Story', 'Antique-finish choker shot in the studio'),
  reel('reel-04', 'Velvet & CZ', 'A CZ suite laid out on green velvet'),
  reel('reel-05', 'Bracelet & Pendant', 'Rose gold bracelet beside a pendant set'),
  reel('reel-06', 'Sapphire Set', 'Blue sapphire necklace with matched drops'),
  reel('reel-07', 'Kundan Pendant', 'A temple-work kundan pendant on wood'),
  reel('reel-08', 'Ring Trio', 'Three stone-set rings side by side'),
];

export const brand = {
  logoColor: '/media/brand/logo-color.png',
  logoWhite: '/media/brand/logo-white.png',
  mark: '/media/brand/logo-mark.png',
  intro: '/media/brand/intro.mp4',
};
